import {Component} from '@angular/core';
import {MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {NgIf} from "@angular/common";
import {ModalHeaderComponent} from '../../../layout/modal-header/modal-header.component';

/** The rebrand announcement. Shown once per browser on first visit (see UserComponent) and
 *  reachable afterwards from the bottom of the nav. The two hosts live here rather than in
 *  environment.ts because they are the same on dev and prod: this is a message about the
 *  domains themselves, not a per-environment endpoint. */
export const NEW_APP_HOST = 'app.onionos.io'
export const NEW_SITE = 'https://onionos.io'
export const ON_OLD_DOMAIN = location.hostname.endsWith('datamorf.io')
/** Same page, new host, so a nudge doesn't dump someone back on the dashboard. Read at call time,
 *  not module load: the path changes as the user navigates, and reset/validate links carry an
 *  oobCode in the query string that must survive the hop. */
export const newAppUrl = () => `https://${NEW_APP_HOST}${location.pathname}${location.search}${location.hash}`

@Component({
  selector: 'app-rebrand-info',
  templateUrl: './rebrand-info.component.html',
  imports: [ModalHeaderComponent, MatDialogContent, NgIf]
})
export class RebrandInfoComponent {
  readonly newSite = NEW_SITE
  readonly newAppHost = NEW_APP_HOST
  readonly newAppUrl = newAppUrl()
  readonly onOldDomain = ON_OLD_DOMAIN

  constructor(
    public dialogRef: MatDialogRef<RebrandInfoComponent>,
  ) { }
}
